import React, { useDebugValue, useEffect, useState } from "react";
import "./numberInput.scss";
import { debounce } from "../../helpers/debounse";

const NumberInput = ({ placeholder, type, inputValue, editElementHandler }) => {
    const [sortValue, setSortValue] = useState("");

    useEffect(() => {
        setSortValue(inputValue);
    }, [inputValue]);

    const changeSortValueHandler = (num) => {
        setSortValue(+num);
        debounce(editElementHandler(null, +num), 1000);
    };

    return (
        <input
            placeholder={placeholder}
            type={type}
            autoComplete="true"
            className="number-input"
            value={sortValue}
            onChange={(e) => changeSortValueHandler(e.target.value)}
        />
    );
};

export default NumberInput;
